import React, { useState } from "react";
import { Col, Row, Form, InputGroup, Button } from '@themesberg/react-bootstrap';
import { useTranslation } from "react-i18next";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
export const ChangePasswordForm = ({ formData, onChange }) => {
    const { t } = useTranslation();
    const [showCurrent, setShowCurrent] = useState(false);
    const [showNew, setShowNew] = useState(false);

    return (
        <div className="mt-4">
            <h5 className="mb-3">{t("ChangePassword")}</h5>
            <Row>
                {/* Current Password */}
                <Col md={6} className="mb-3">
                    <Form.Group id="currentPassword">
                        <Form.Label>{t("CurrentPassword")}</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showCurrent ? "text" : "password"}
                                 placeholder={t("CurrentPassword")}
                                value={formData.currentPassword || ""}
                                onChange={(e) => onChange("currentPassword", e.target.value)}
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowCurrent(!showCurrent)}
                            >
                                <FontAwesomeIcon icon={showCurrent ? faEyeSlash : faEye} style={{ color: "black" }} />
                            </Button>
                        </InputGroup>
                    </Form.Group>
                </Col>

                {/* New Password */}
                <Col md={6} className="mb-3">
                    <Form.Group id="newPassword">
                        <Form.Label>{t("NewPassword")}</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showNew ? "text" : "password"}
                                placeholder={t("NewPassword")}
                                value={formData.newPassword || ""}
                                onChange={(e) => onChange("newPassword", e.target.value)}
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowNew(!showNew)}
                            >
                                <FontAwesomeIcon icon={showNew ? faEyeSlash : faEye} style={{ color: "black" }} />
                            </Button>
                        </InputGroup>
                    </Form.Group>
                </Col>
            </Row>
        </div>
    );
};
